import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { selectedCompanyStorage } from '../../storage/company/selected-company.util';
import { toNumber } from '../../utils/to-number.util';
import { useAppQuery } from '../use-app-query.hook';

export const useIssuedShares = ({
  companyId,
  enabled = true,
}: {
  companyId: string;
  enabled?: boolean;
}) => {
  const queryClient = useQueryClient();
  const company = selectedCompanyStorage(({ company }) => company);
  const isCompanyContextReady = company?.id === companyId;

  const { data: issuedShares, isLoading } = useAppQuery<number>({
    queryKey: [QueryKey.GET_ISSUED_SHARES, companyId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'issued-shares'],
      }),
    enabled: !!companyId && enabled && isCompanyContextReady,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_ISSUED_SHARES] });
  }, [queryClient]);

  return {
    invalidateQuery,
    issuedShares: toNumber(issuedShares),
    isLoading,
  };
};
